import React, { useState } from "react";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import { Eye, XCircle } from "react-feather";
import AdminBookingNavbar from "./AdminReport/AdminBookingNavbar";

function AdminBooking() {
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(5);

  const bookingData = [
    {
      id: 1,
      customerName: "John Doe",
      bookingDate: "2023-12-01",
      departureFrom: "New York",
      departureTo: "Los Angeles",
      travelingDate: "2023-12-15",
      travelingMode: "Airways",
      bookingStatus: "Confirmed",
      bookedByStaff: "Jane Smith",
      invoice: "INV001",
    },
    {
      id: 2,
      customerName: "Sarah Connor",
      bookingDate: "2023-12-05",
      departureFrom: "Chicago",
      departureTo: "Miami",
      travelingDate: "2023-12-20",
      travelingMode: "Bus",
      bookingStatus: "Pending",
      bookedByStaff: "Mike Taylor",
      invoice: "INV002",
    },
    // Add more booking data for testing
  ];

  const filteredBookings = bookingData.filter(
    (booking) =>
      booking.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.departureFrom.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.departureTo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalRecords = filteredBookings.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);
  const startIndex = (currentPage - 1) * recordsPerPage;
  const paginatedBookings = filteredBookings.slice(
    startIndex,
    startIndex + recordsPerPage
  );

  const handleView = (booking) => {
    setSelectedBooking(booking);
    const modal = new window.bootstrap.Modal(
      document.getElementById("bookingDetailModal")
    );
    modal.show();
  };

  const handleCancel = (id) => {
    alert(`Booking ID ${id} canceled.`);
  };

  const handlePageChange = (page) => setCurrentPage(page);

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <BreadCrumb />
          <div className="container-fluid">


<AdminBookingNavbar/>


            <div className="crdmain mb-2">
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                <h2 className="chart-title mb-0">All Bookings</h2>
              </div>

              <div className="row g-1 mt-0 mb-0 justify-content-end">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="input1"
                    placeholder="Search by name, departure"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div className="col-md-1 text-end">
                  <select
                    className="input1"
                    value={recordsPerPage}
                    onChange={handleRecordsPerPageChange}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                  </select>
                </div>
              </div>

              <div className="row g-2 mt-0 mb-0">
                <div className="col-md-12 p-0">
                  <div className="table-responsive classic-table">
                    <table className="table table-striped table-hover">
                      <thead className="table-header">
                        <tr>
                          <th>#</th>
                          <th>Customer Name</th>
                          <th>Booking Date</th>
                          <th>From</th>
                          <th>To</th>
                          <th>Traveling Date</th>
                          <th>Mode</th>
                          <th>Status</th>
                          <th>Booked By</th>
                          <th>Invoice</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedBookings.length > 0 ? (
                          paginatedBookings.map((booking, index) => (
                            <tr key={booking.id}>
                              <td>{startIndex + index + 1}</td>
                              <td>{booking.customerName}</td>
                              <td>{booking.bookingDate}</td>
                              <td>{booking.departureFrom}</td>
                              <td>{booking.departureTo}</td>
                              <td>{booking.travelingDate}</td>
                              <td>{booking.travelingMode}</td>
                              <td>{booking.bookingStatus}</td>
                              <td>{booking.bookedByStaff}</td>
                              <td>{booking.invoice}</td>
                              <td>
                                <span
                                  className="btn2 me-2"
                                  title="View"
                                  onClick={() => handleView(booking)}
                                >
                                  <Eye size={15} />
                                </span>
                                <span
                                  className="btn2"
                                  title="Cancel"
                                  onClick={() => handleCancel(booking.id)}
                                >
                                  <XCircle size={15} />
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="11" className="text-center">
                              No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <nav>
                  <ul className="pagination">
                    {[...Array(totalPages)].map((_, index) => (
                      <li
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                        key={index}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="bookingDetailModal"
        tabIndex="-1"
        aria-labelledby="bookingDetailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="bookingDetailModalLabel">
                Booking Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {selectedBooking && (
                <>
                  <p>
                    <strong>Customer Name:</strong> {selectedBooking.customerName}
                  </p>
                  <p>
                    <strong>Booking Date:</strong> {selectedBooking.bookingDate}
                  </p>
                  <p>
                    <strong>Departure From:</strong> {selectedBooking.departureFrom}
                  </p>
                  <p>
                    <strong>Departure To:</strong> {selectedBooking.departureTo}
                  </p>
                  <p>
                    <strong>Traveling Date:</strong> {selectedBooking.travelingDate}
                  </p>
                  <p>
                    <strong>Traveling Mode:</strong> {selectedBooking.travelingMode}
                  </p>
                  <p>
                    <strong>Status:</strong> {selectedBooking.bookingStatus}
                  </p>
                  <p>
                    <strong>Booked By:</strong> {selectedBooking.bookedByStaff}
                  </p>
                  <p>
                    <strong>Invoice:</strong> {selectedBooking.invoice}
                  </p>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminBooking;
